import { render, staticRenderFns } from "./Covid19Box.vue?vue&type=template&id=5214e912&scoped=true"
import script from "./Covid19Box.vue?vue&type=script&lang=js"
export * from "./Covid19Box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5214e912",
  null
  
)

export default component.exports